<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body sec-form">
                <b-row class="mt-1">
                    <b-col md="12" class="text-center mt-3" v-if="loading_page === true">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </b-col>

                    <template v-if="loading_page === false">
                        <b-col md="4">
                            <div class="card bdr-15">
                                <div class="card-body">
                                    <ul class="nav nav-pills flex-column nav-profile">
                                    <li v-for="data in profile_menu" :key="data.id" class="nav-item">
                                        <a href="#" @click.prevent="profile_menu_active = data.id" :class="profile_menu_active === data.id ? 'active' : ''" class="nav-link">{{data.label}}</a>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </b-col>

                        <b-col md="8">
                            <div class="card bdr-15">
                                <div class="card-body">
                                    <ValidationObserver ref="form">

                                        <template v-if="profile_menu_active === 1">

                                            <validation-provider v-if="!formprofile.photo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                                <div class="form-group">
                                                    <div class="mb-1">
                                                        <label>Profile Photo</label>
                                                    </div>
                                                    <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                                    </div>
                                                    <input ref="inputImage"
                                                            type="file"
                                                            class="custom-file-input d-none"
                                                            id="Thumbnail"
                                                            v-on:change="onProfileImageChange"
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            @input="validate" >

                                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <div class="form-group" v-if="formprofile.photo">
                                                <div class="mb-1">
                                                    <label>Profile Photo</label>
                                                </div>
                                                <button v-on:click.prevent="removeProfileImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button>
                                                <div class="input-group img-sh s-medium">
                                                    <img :src="formprofile.photo" class="img-responsive img-prf">
                                                </div>
                                            </div>

                                            <validation-provider rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Name</label>
                                                    <input v-model="formprofile.name" type="text" class="form-control" name="categories">
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <validation-provider rules="required|email" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Email</label>
                                                    <input disabled v-model="formprofile.email" type="email" class="form-control daterange-cus">
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <button type="button" v-on:click="validationForm('profile')"  v-bind:class="loading ? 'btn-progress' : ''" class="btn btn-grey mr-2">
                                                <i class="uil uil-save"></i> Change Profile
                                            </button>

                                        </template>

                                        <template v-if="profile_menu_active === 2">
                                        
                                            <div class="form-group">
                                                <label>Agent Code</label>
                                                <input disabled v-model="formprofile.code" type="text" class="form-control" name="categories">
                                            </div>

                                            <validation-provider v-if="!formprofile.logo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                                <div class="form-group">
                                                    <div class="mb-1">
                                                        <label>Brand Logo</label>
                                                    </div>
                                                    <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                                    </div>
                                                    <input ref="inputImage"
                                                            type="file"
                                                            class="custom-file-input d-none"
                                                            id="Thumbnail"
                                                            v-on:change="onLogoImageUpload"
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            @input="validate" >

                                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <div class="form-group" v-if="formprofile.logo">
                                                <div class="mb-1">
                                                    <label>Brand Logo</label>
                                                </div>
                                                <button v-on:click.prevent="removeLogoImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button>
                                                <div class="input-group img-sh s-medium">
                                                    <img :src="formprofile.logo" class="img-responsive img-prf">
                                                </div>
                                            </div>

                                            <validation-provider rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Brand Name</label>
                                                    <input v-model="formprofile.brand" type="text" class="form-control" name="categories">
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <validation-provider rules="multi_url" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Social Media</label>
                                                    <textarea v-model="formprofile.sosmed_link" class="form-control"></textarea>
                                                    <small>Separate urls with commas(,) if you want to load more than one link</small>
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <button type="button" v-on:click="validationForm('brand')"  v-bind:class="loading ? 'btn-progress' : ''" class="btn btn-grey mr-2">
                                                <i class="uil uil-save"></i> Change Profile
                                            </button>

                                        </template>

                                        <template v-if="profile_menu_active === 3">

                                            <validation-provider name="confirm" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <div class="d-block">
                                                        <label for="password" class="control-label">New Password</label>
                                                    </div>
                                                    <input id="password" type="password" v-model="formprofile.password" class="form-control" name="password2">
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <validation-provider rules="required|password:@confirm" v-slot="{ errors }" v-if="formprofile.password !== ''">
                                                <div class="form-group">
                                                    <div class="d-block">
                                                        <label for="confirm" class="control-label">New Password Confirmation</label>
                                                    </div>
                                                    <input id="confirm" type="password" v-model="formprofile.confirmation" class="form-control" name="confirm">
                                                    <div class="invalid-input">{{ errors[0] }}</div>
                                                </div>
                                            </validation-provider>

                                            <button type="button" v-on:click="validationForm('password')"  v-bind:class="loading ? 'btn-progress' : ''" class="btn btn-grey mr-2">
                                                <i class="uil uil-save"></i> Change Password
                                            </button>
                                        </template>

                                    </ValidationObserver>
                                </div>
                            </div>
                        </b-col>
                    </template>

                </b-row>

            </div>
        </section>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver, extend } from "vee-validate";

     extend('password', {
        params: ['target'],
        validate(value, { target }) {
            return value === target;
        },
        message: 'Confirmation Password Not Same'
    });

    export default {
        name: "users",
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data(){
            return {
                loading_page: false,
                loading: false,
                profile_image_file: '',
                logo_image_file:'',
                accept_file : 'image/jpeg,image/png,image/jpg',

                profile_menu:[{id:1,label:'Profile'},{id:2,label:'Brand'},{id:3,label:'Password'}],
                profile_menu_active:1,
            }
        },
        mounted(){
            this.loading_page = true,
            this.getProfile().then(() => {
                this.loading_page = false
            })
        },
        computed:{
            ...mapState('UsersControl', {
                errors: state => state.errors,
                formprofile: state => state.formprofile,
            }),
        },
        watch:{
            errors:function(val){
                if(val.email){
                    this.$toast.warning('Email Yang Anda Masukan Sudah Digunakan')
                    this.loading = false
                }
            },
        },
        methods: {
            ...mapActions('UsersControl', ['getProfile','updateProfile']),
            ...mapMutations('UsersControl', ['CLEAR_FORM']),

            onLogoImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formprofile.logo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.logo_image_file = input.files[0]
            },
            removeLogoImageUpload:function(){
                this.logo_image_file = ''
                this.formprofile.logo = ''
            },

            onProfileImageChange: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formprofile.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.profile_image_file = input.files[0]
            },
            removeProfileImageUpload:function(){
                this.profile_image_file = ''
                this.formprofile.photo = ''
            },

            validationForm: function(type) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true
                        var formData = new FormData();

                        formData.append('type', type);
                        formData.append('name', this.formprofile.name);
                        formData.append('profile_file', this.profile_image_file);
                        formData.append('profile_photo', this.formprofile.photo ? this.formprofile.photo : '');

                        formData.append('brand', this.formprofile.brand);
                        formData.append('sosmed_link', this.formprofile.sosmed_link);
                        formData.append('logo', this.formprofile.logo ? this.formprofile.logo : '');
                        formData.append('logo_file', this.logo_image_file);

                        formData.append('password', this.formprofile.password ? this.formprofile.password : '');
                        formData.append("_method", "put");

                        this.updateProfile(formData).then(() => {
                            this.getProfile();
                            this.loading = false
                            this.$toast.success('Successfully Change Profile')
                            this.$bvModal.hide('bv-modal-Change-Password')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                });
            },
        },
    };

</script>
